require('./bootstrap');

import Vue from 'vue';
//Rutas del website
import Router from './router.js';

//Librerias globales
import Library from './libs.js';
Vue.use(Library);

//Componentes del website
import components from './components/components.js';
Vue.use(components);

window.Vue=Vue;

//Instancia principal
const app = new Vue({
  el: '#app',
  router:Router,

  data:{
    logged: false,
    user: {},
  },
  methods:{
      auth:function(){
            axios.get(tools.url("/api/user")).then((response)=>{
              this.user = response.data;
              this.logged = true;
              if(this.user.validate_verification_code == 0){
                  this.handleLogout();
              }
          }).catch(()=>{
            //no login
        });
      },
      handleErrors:function(errors){
      
        var err="";

        if (errors.response) {
            if(errors.response.data.message){
              if(errors.response.data.message != 'The given data was invalid.'){
                err+=errors.response.data.message+"<br>";
              }
            }
            if(errors.response.data.msg){
                err+=errors.response.data.msg+"<br>";
            }
            if(errors.response.data.errors){
                jQuery.each(errors.response.data.errors,(k,v)=>{
                    err+=v[0]+"<br>";
                });
            }
        }
        else{
            err="Error desconocido.";
        }
        return err;
        
    },
  },
  mounted:function(){
    this.auth();
  }
});
